function setScreenSize() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let scrollSpyIdx = 0;
const header = {
	bg() {
		const $header = $('.app-header');

		if (!$header) return;

		let trigger =
			$('.job-vacancy').offset().top - $header.outerHeight(true);
		let pageYoffset = window.pageYOffset;
		if (pageYoffset > trigger) {
			$header.addClass('is-bg is-active');
		} else {
			$header.removeClass('is-bg is-active');
		}
	},
	scrollSpy(e) {
		let _this = e;

		const $scrollSpy = $('[data-spy="scroll"]');
		let pageYoffset = window.pageYOffset;

		$scrollSpy.each((i, v) => {
			// console.log(i, v);
			if (
				pageYoffset >= $(v).offset().top - window.innerHeight / 2 &&
				pageYoffset <
					$(v).offset().top +
						$(v).outerHeight(true) -
						window.innerHeight / 2
			) {
				scrollSpyIdx = i;
			}
		});
		$('.navigation li')
			.eq(scrollSpyIdx)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	},
	state(e) {
		let _this = e.currentTarget;
		if (_this.checked) {
			document.querySelector('html').classList.add('hidden');
		} else {
			document.querySelector('html').classList.remove('hidden');
		}
	},
	handler() {
		$('.menu-state').on('change', (e) => this.state(e));
		$('.navigation-button').on('click', (e) => {
			this.menuInactive();
			this.move(e);
		});
	},
	move(e) {
		let _this = e.currentTarget;
		let _idx = $(_this).parent().index();
		const $scrollSpy = $('[data-spy="scroll"]');
		let moveY =
			$scrollSpy.eq(_idx).offset().top -
			$('.app-header').outerHeight(true);
		setTimeout(() => {
			gsap.to('html, body', {
				scrollTop: moveY,
			});
		});
	},
	resize() {
		let scr = window.innerWidth - window.visualViewport.width;
		let wSize = window.innerWidth - scr;
		if (wSize >= 1280) {
			document.querySelector('html').classList.remove('hidden');
			document.querySelector('.menu-state').checked = false;
		}
		this.bg();
	},
	menuActive() {
		$('.menu-state').prop('checked', true);
		document.querySelector('html').classList.add('hidden');
	},
	menuInactive() {
		$('.menu-state').prop('checked', false);
		document.querySelector('html').classList.remove('hidden');
	},
};

const cancelClick = {
	handler(e) {
		let _this = e.target;
		if (
			!_this.classList.contains('social-state') &&
			!_this.classList.contains('social-state-button')
		) {
			document.querySelector('.social-state').checked = false;
		}
	},
};

const aboutVideoClass = '.js-video-swiper';
let aboutVideoSwiper;
const aboutVideo = {
	swiper() {
		if (!$(aboutVideoClass).length) return;
		aboutVideoSwiper = new Swiper(aboutVideoClass, {
			slidesPerView: 1.05,
			spaceBetween: 16,
			observer: true,
			observeParents: true,
			// slideToClickedSlide: true,
			// breakpointsInverse: true,
			speed: 400,
			breakpoints: {
				1280: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
			},
			pagination: {
				el: `${aboutVideoClass} .swiper-pagination`,
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: `${aboutVideoClass} .swiper-button-next`,
				prevEl: `${aboutVideoClass} .swiper-button-prev`,
			},
			on: {
				slideChange() {
					aboutVideoAction.stopVideo();
				},
			},
		});
	},
};

const welfareSystemClass = '.js-welfare-system-swiper';
let welfareSystemSwiper;
const welfareSystem = {
	swiper() {
		welfareSystemSwiper = new Swiper(welfareSystemClass, {
			slidesPerView: 1,
			spaceBetween: 16,
			// freeMode: true,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
			speed: 400,
			breakpoints: {
				1280: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
			pagination: {
				el: `${welfareSystemClass} .swiper-pagination`,
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: `${welfareSystemClass} .swiper-button-next`,
				prevEl: `${welfareSystemClass} .swiper-button-prev`,
			},
		});
	},
};

let tabFocus = 0;
let $tabs = document.querySelectorAll('[role="tab"]');
let $tabList = document.querySelector('[role="tablist"]');
const tabAction = {
	init: function () {
		if (!$tabs.length) return;
		tabAction.click();
		tabAction.keydown();
	},
	click: function () {
		$tabs.forEach(function (e) {
			e.addEventListener('click', tabAction.changeTabs);
		});
	},
	keydown: function () {
		$tabList.addEventListener('keydown', tabAction.changeFocus);
	},
	changeTabs: function (e) {
		var $target = e.currentTarget;
		var $parent = $target.parentNode;
		var $grandparent = $parent.parentNode;

		$parent
			.querySelectorAll('[aria-selected="true"]')
			.forEach(function (i) {
				i.setAttribute('aria-selected', false);
			});

		$target.setAttribute('aria-selected', true);
		$grandparent
			.querySelectorAll('[role="tabpanel"]')
			.forEach(function (i) {
				i.setAttribute('hidden', true);
			});
		$grandparent.parentNode
			.querySelector(`#${$target.getAttribute('aria-controls')}`)
			.removeAttribute('hidden');
	},
	changeFocus: function (e) {
		if (e.keyCode === 39 || e.keyCode === 37) {
			if (e.keyCode === 39) {
				tabFocus++;
				if (tabFocus >= $tabs.length) {
					tabFocus = 0;
				}
			} else if (e.keyCode === 37) {
				tabFocus--;
				if (tabFocus < 0) {
					tabFocus = $tabs.length - 1;
				}
			}
			$tabs[tabFocus].focus();
		}
	},
};

const freeModeSwiperClass = '.js-free-mode-swiper';
let freeModeSwiper;
const freeMode = {
	init() {
		this.handler();
		this.swiper();
	},
	swiper() {
		freeModeSwiper = new Swiper(freeModeSwiperClass, {
			slidesPerView: 'auto',
			spaceBetween: 20,
			freeMode: true,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
			speed: 400,
			breakpoints: {
				1280: {
					spaceBetween: 50,
				},
			},
			// navigation: {
			// 	nextEl: `${freeModeSwiperClass} .swiper-button-next`,
			// 	prevEl: `${freeModeSwiperClass} .swiper-button-prev`,
			// },
		});
	},
	handler() {
		$('.free-mode-tablist, .free-mode-tablist-st02').on(
			'click',
			'.free-mode-tab',
			(e) => {
				this.click(e);
			}
		);
	},
	click(e) {
		let _this = e.currentTarget;
		let _index = $(_this).parent().index();
		let _moveY =
			$(_this).closest('.paper-main').offset().top -
			$('.app-header').outerHeight(true);
		const $tabpanel = $(_this)
			.closest('.paper-main')
			.find('.free-mode-tabpanel');

		$(_this)
			.parent()
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
		$tabpanel.attr('hidden', true);
		$tabpanel.eq(_index).removeAttr('hidden');
		e.delegateTarget.swiper.slideTo(_index - 1);
		gsap.to('html, body', { scrollTop: _moveY });
	},
	scroll() {
		let pageY = window.pageYOffset;
		const $triggerY = $('.paper-main');

		$triggerY.each((i, v) => {
			if (pageY >= $(v).offset().top) {
				$(v).addClass('is-shadow');
			} else {
				$(v).removeClass('is-shadow');
			}
		});
		// if (pageY >= )
	},
};

const agContent = {
	resize() {
		$('.ag-process-content').attr(
			'style',
			`--process-size:${$('.ag-process-content').width()}px`
		);
	},
};

// Youtube Player
var $player = $('.video-player');
var youtubePlayerAction = {
	init: function () {
		youtubePlayerAction.tag();
	},
	tag: function () {
		var tag = document.createElement('script');

		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},
};
if ($player.length) youtubePlayerAction.init();

// About Video
var $aboutVideoPlayer = $('.video-player');
var aboutVideoData = $aboutVideoPlayer.parent().attr('data-youtube');
var aboutVideoPlayerDone = false;
var aboutVideoPlayer01, aboutVideoPlayer02, aboutVideoPlayer03;
var aboutVideoAction = {
	init: function () {
		$(window).on('load', function () {
			aboutVideoAction.playerSet();

			$('.video-player-button').on('click', function () {
				var idx = $(this).closest('.swiper-slide').index();

				if (idx === 0) {
					aboutVideoPlayer01.playVideo();
				} else if (idx === 1) {
					aboutVideoPlayer02.playVideo();
				} else if (idx === 2) {
					aboutVideoPlayer03.playVideo();
				}
			});
		});
	},
	playerSet: function () {
		// Youtube 01
		aboutVideoPlayer01 = new YT.Player('video-player01', {
			autoplay: 1,
			videoId: 'Zjh1RRlEQIE',
			events: {
				onStateChange: aboutVideoAction.stateChange,
			},
			playerVars: {
				rel: 0,
				controls: 1,
				color: 'white',
			},
		});

		// Youtube 02
		aboutVideoPlayer02 = new YT.Player('video-player02', {
			autoplay: 1,
			videoId: 's5eyPlhFcM4',
			events: {
				onStateChange: aboutVideoAction.stateChange,
			},
			playerVars: {
				rel: 0,
				controls: 1,
				color: 'white',
			},
		});

		// Youtube 03
		aboutVideoPlayer03 = new YT.Player('video-player03', {
			autoplay: 1,
			videoId: 'reTNMQzTeqg',
			events: {
				onStateChange: aboutVideoAction.stateChange,
			},
			playerVars: {
				rel: 0,
				controls: 1,
				color: 'white',
			},
		});
	},
	stateChange: function (e) {
		if (e.data == YT.PlayerState.PLAYING && !aboutVideoPlayerDone) {
			aboutVideoPlayerDone = true;
			$('.video-content').addClass('video-playing');
		} else {
			aboutVideoPlayerDone = false;
			$('.video-content').removeClass('video-playing');
		}
	},
	stopVideo: function () {
		if (YT.loading >= 1) {
			aboutVideoPlayer01.stopVideo();
			aboutVideoPlayer02.stopVideo();
			aboutVideoPlayer03.stopVideo();
		}
	},
};
if ($aboutVideoPlayer.length) aboutVideoAction.init();

const quickButton = {
	init() {
		this.handler();
	},
	scroll() {
		let pageY = window.pageYOffset;
		let $quickButton = $('.app-quick');
		let triggerY = window.innerHeight / 3;
		if (pageY > triggerY) {
			$quickButton.addClass('is-show');
		} else {
			$quickButton.removeClass('is-show');
		}
	},
	handler() {
		$('.app-quick__button--top').on('click', this.click);
	},
	click() {
		gsap.to('html, body', { scrollTop: 0 });
	},
};

window.addEventListener('DOMContentLoaded', (e) => {
	freeMode.init();
	aboutVideo.swiper();
	welfareSystem.swiper();
	tabAction.init();
	header.handler();
	header.bg();
	header.scrollSpy(e);
	agContent.resize();
	freeMode.scroll();
	quickButton.init();
});
window.addEventListener('click', (e) => cancelClick.handler(e));
window.addEventListener('resize', () => {
	setScreenSize();
	header.resize();
	agContent.resize();
	freeMode.scroll();
});
window.addEventListener('scroll', (e) => {
	header.bg();
	header.scrollSpy(e);
	freeMode.scroll();
	quickButton.scroll();
});

// init
const initFn = () => {
	// scrollSpy.init();
};

// IIFE
(() => {
	initFn();
	setScreenSize();
})();
